import { gql } from '@apollo/client';

const ADD_EMAIL_SUBSCRIPTION = gql`
  mutation AddEmailSubscription(
    $email: String!
    $firstName: String!
    $lastName: String!
    $sbuId: ID!
    $source: String!
  ) {
    addEmailSubscription(
      email: $email
      sbuId: $sbuId
      firstName: $firstName
      lastName: $lastName
      source: $source
    ) {
      success
      errors
      subscription {
        id
        source
        status
        bouncedAt
        confirmedAt
        createdAt
        emailAccount {
          id
          emailAddress
        }
      }
    }
  }
`;

const CONFIRM_EMAIL_SUBSCRIPTION = gql`
  mutation ConfirmEmailSubscription(
    $uid: String!
    $subscriptionId: ID!
    $token: String!
  ) {
    confirmEmailSubscription(
      uid: $uid
      subscriptionId: $subscriptionId
      token: $token
    ) {
      success
      errors
      subscription {
        id
        status
        confirmedAt
      }
    }
  }
`;

const UNSUBSCRIBE_EMAIL_SUBSCRIPTION = gql`
  mutation UnsubscribeEmailSubscription(
    $uid: String!
    $sbuId: ID!
    $token: String!
  ) {
    unsubscribeEmailSubscription(
      input: { uid: $uid, sbuId: $sbuId, token: $token }
    ) {
      success
      errors
      subscription {
        id
        status
        unsubscribedAt
      }
    }
  }
`;

const ADD_PRODUCT_WAITLIST = gql`
  mutation AddProductWaitlist(
    $productCode: String!
    $name: String!
    $email: String!
    $phone: String
  ) {
    addProductWaitlist(
      productCode: $productCode
      name: $name
      email: $email
      phone: $phone
    ) {
      success
      errors
      waitlistEntry {
        id
        name
        email
        status
        createdAt
      }
    }
  }
`;

export {
  ADD_EMAIL_SUBSCRIPTION,
  CONFIRM_EMAIL_SUBSCRIPTION,
  UNSUBSCRIBE_EMAIL_SUBSCRIPTION,
  ADD_PRODUCT_WAITLIST,
};
